import React from 'react'
import { MotionCard, MotionSection } from '../motion/Motion'

export default function WhyInvestSection() {
  return (
    <MotionSection className="w-[96%] mx-auto py-14">
      <div className="max-w-7xl mx-auto">
        {/* Text column */}
        <div className="grid gap-6 lg:grid-cols-2 items-start">
          <div className="space-y-3 text-left">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
              Why Invest in Logo Branded Door Mats Zambia?
              <br />
              <span className="text-pink-500">Maximize Your Branding ROI.</span>
            </h2>
          </div>
          <div className="text-left">
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              Choosing the right partner for your commercial matting is a critical business decision. Consequently,
              Zambian facility managers and marketing teams trust us because we eliminate the common pain points
              associated with regional and international sourcing:
            </p>
          </div>
        </div>

        <div className="mt-10 lg:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 items-start">
          {/* Column 1 */}
          <MotionCard
            className="bg-pink-50 border border-pink-100 rounded-xl px-5 py-6 shadow-sm text-center flex flex-col items-center"
            delay={0.02}
          >
            <div className="h-10 w-10 rounded-full bg-pink-500 text-white flex items-center justify-center text-sm font-semibold mb-3">
              01
            </div>
            <h3 className="font-semibold text-gray-900 text-sm sm:text-base mb-2">
              Superior, Fade-Resistant Quality (The Durability Advantage)
            </h3>
            <p className="text-[13px] text-gray-600 leading-relaxed text-center">
              <span className="font-semibold">Challenge Solved:</span> Locally printed mats quickly fail under
              high-traffic and harsh sun.
              <br />
              <span className="font-semibold">Our Solution:</span> We utilize precision-inlaid WaterHog and HD Nylon
              technologiesthe global standard for commercial matting. This ensures your logo remains crisp,
              vibrant, and visible for years. Invest in a mat that lasts.
            </p>
          </MotionCard>

          {/* Column 2 */}
          <MotionCard
            className="bg-pink-50 border border-pink-100 rounded-xl px-5 py-6 shadow-sm text-center flex flex-col items-center"
            delay={0.07}
          >
            <div className="h-10 w-10 rounded-full bg-pink-500 text-white flex items-center justify-center text-sm font-semibold mb-3">
              02
            </div>
            <h3 className="font-semibold text-gray-900 text-sm sm:text-base mb-2">
              Zambian-Optimised Lead Times (The Speed Advantage)
            </h3>
            <p className="text-[13px] text-gray-600 leading-relaxed text-center">
              <span className="font-semibold">Challenge Solved:</span> Standard regional lead times are often 6 to 8
              weeks, causing unacceptable delays.
              <br />
              <span className="font-semibold">Our Solution:</span> We manage the import logistics and local finishing
              process efficiently, dramatically reducing your waiting period. Take control of your timeline with the
              fastest turnarounds available in Lusaka, Ndola, and Kitwe.
            </p>
          </MotionCard>

          {/* Column 3 */}
          <MotionCard
            className="bg-pink-50 border border-pink-100 rounded-xl px-5 py-6 shadow-sm text-center flex flex-col items-center"
            delay={0.12}
          >
            <div className="h-10 w-10 rounded-full bg-pink-500 text-white flex items-center justify-center text-sm font-semibold mb-3">
              03
            </div>
            <h3 className="font-semibold text-gray-900 text-sm sm:text-base mb-2">
              Hassle-Free Local Service (The Convenience Advantage)
            </h3>
            <p className="text-[13px] text-gray-600 leading-relaxed text-center">
              <span className="font-semibold">Challenge Solved:</span> Dealing with international logistics, duties,
              and ZRA paperwork is complex.
              <br />
              <span className="font-semibold">Our Solution:</span> We handle everything. Deal with a local team, pay
              securely in Zambian Kwacha (ZMW), and enjoy free, door-to-door delivery and optional onsite consultation
              in all major cities. Simplify your procurement process.
            </p>
          </MotionCard>
        </div>
      </div>
    </MotionSection>
  )
}
